<template>
    <div class="verses-quotes-container my-6 px-12 text-center">
        <div v-for="(verse, index) in content" :key="index" class="py-6 verse-container">
            
            <div v-html="verse.verseQuoteText" class=""></div>
            
            <div v-html="verse.verseQuoteReference" class="mt-3 font-weight-bold"></div>
            
            <!-- <v-divider v-if="verse" class="dashed"></v-divider> -->
        
        </div>
    </div>
</template>

<script>

export default {
    name: 'UserVersesQuotes',
    props: ['content', 'section'],
    data() {
        return {}
    },
}
</script>

<style>
.units-container .verses-quotes-container .v-expansion-panel {
    border:1px solid #B5B5B5;
}
.verses-quotes-container .v-expansion-panels > div {
    width: 100%;
}
.verses-quotes-container .v-expansion-panel__header {
    cursor:grab;
}
.verses-quotes-container .response-lines .theme--light.v-messages {
    color: #000;
}
.verses-quotes-container .response-lines .v-label {
    font-size: 13px;
}
.verses-quotes-container .v-expansion-panels .snippet-autosave-status.busy .snippet-autosave-status_spinner-label::after {
    content: 'Preparing...';
}
.verses-quotes-container .v-expansion-panels .snippet-autosave-status_spinner-label::after {
    content: 'Ready!';
}
</style>